export const menuTitle = { title: "GROUP POSITION", label: "Group Position" }
  